import React, { useState } from "react";
import pictureOne from "./assets/picOne.png";

const TechnicalCommittees = () => {
  const [popup, setPopup] = useState({ show: false, type: "" });
  const [showPdf, setShowPdf] = useState(false);

  const openPopup = (type) => setPopup({ show: true, type });
  const closePopup = () => setPopup({ show: false, type: "" });

  const getPopupContent = () => {
    if (popup.type === "committeeExample") {
      return {
        heading: "",
        body: ``,
      };
    }
    return { heading: "", body: "" };
  };

  const content = getPopupContent();

  return (
    <div className="about-us">
      {/* === Header Section === */}
      <section className="about-header">
        <div className="overlay">
          <h1 className="page-title">Technical Committees</h1>
          <p className="subtitle">
            Promoting standardization and quality assurance in Malawi.
          </p>
        </div>
      </section>

      {/* === Main Content Section === */}
      <section className="content-section">
        <p>
          Formulation of Malawi standards is done through Technical Committees
          whose membership covers representatives from the industry,
          government, non-governmental organizations, professional bodies,
          consumers and other interested parties. Officers in the Standards
          Development Department serve as Secretariats of these TCs.
          <br /><br />
          This is the current list of{" "}
          <span
            onClick={() => setShowPdf(true)}
            style={{
              color: "red",
              cursor: "pointer",
              textDecoration: "none",
            }}
          >
            Technical Committees
          </span>
          .
          <br /><br />
          Any interested stakeholder may apply for consideration for TC
          membership using the{" "}
          <a href="/mbs-board" style={{ color: "red", textDecoration: "none" }}>
            TC membership application form
          </a>
          .
        </p>
      </section>

      {/* === PDF Popup Modal === */}
      {showPdf && (
        <div className="popup-overlay">
          <div className="popup pdf-popup">
            <button
              className="close-btn"
              onClick={() => setShowPdf(false)}
            >
              ×
            </button>
            <h2 className="popup-heading">
              List of Technical Committees
            </h2>

            <iframe
              src="/files/List of Technical Committees .pdf"
              title="List of Technical Committees"
              width="100%"
              height="600px"
              style={{
                border: "1px solid #ccc",
                borderRadius: "8px",
              }}
            />
          </div>
        </div>
      )}

      {/* === General Popup Modal === */}
      {popup.show && (
        <div className="popup-overlay">
          <div className="popup">
            <button className="close-btn" onClick={closePopup}>
              ×
            </button>
            <h2 className="popup-heading">{content.heading}</h2>
            <div className="popup-content">
              {content.body
                .split("\n")
                .map((line, i) => (
                  <p key={i}>{line}</p>
                ))}
            </div>
          </div>
        </div>
      )}

      {/* === Inline CSS === */}
      <style>{`
        .about-us {
          font-family: Arial, sans-serif;
          color: #333;
        }

        .about-header {
          background-image: url(${pictureOne});
          background-size: cover;
          background-position: center;
          height: 45vh;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
        }

        .overlay {
          background: rgba(0, 0, 0, 0.55);
          padding: 40px;
          text-align: center;
          color: white;
          width: 90%;
          max-width: 1200px;
          border-radius: 8px;
        }

        .page-title {
          font-size: 2.5rem;
          font-weight: bold;
        }

        .subtitle {
          margin-top: 10px;
          font-size: 1rem;
        }

        .content-section {
          padding: 50px 80px;
          font-size: 1rem;
          line-height: 1.6;
        }

        .content-section p {
          margin-bottom: 20px;
        }

        /* Popup styles */
        .popup-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          backdrop-filter: blur(4px);
          background: rgba(0, 0, 0, 0.4);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 1000;
          animation: fadeIn 0.3s ease;
        }

        .popup {
          background: #fff;
          width: 700px;
          max-width: 95%;
          border-radius: 12px;
          padding: 25px 30px;
          position: relative;
          max-height: 85vh;
          overflow-y: auto;
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.25);
          animation: slideIn 0.3s ease;
        }

        .pdf-popup {
          width: 1200px;
          max-width: 95%;
        }

        .popup-heading {
          font-weight: bold;
          font-size: 1.5rem;
          margin-bottom: 15px;
        }

        .close-btn {
          position: absolute;
          top: 15px;
          right: 15px;
          background: none;
          border: none;
          font-size: 1.8rem;
          cursor: pointer;
        }

        .popup-content p {
          margin-bottom: 12px;
          line-height: 1.6;
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        @keyframes slideIn {
          from {
            transform: translateY(-20px);
          }
          to {
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );
};

export default TechnicalCommittees;
